/* eslint-disable react/jsx-props-no-spreading */
import React, { FC, ReactElement, FocusEvent } from 'react'
import { useTranslations } from 'next-intl'
import { PhoneCodeInput } from '../PhoneCodeInput/PhoneCodeInput'
import style from './CodeInputField.module.css'

type CodeInputFieldProps = {
  name?: string
  className?: string
  placeholder?: string
  disabled: boolean
  isCallCode: boolean
  error?: ReactElement | string | null
  value: string
  onChange?(data: FocusEvent<HTMLInputElement, Element>): void
  onFocus?(data: FocusEvent<HTMLInputElement, Element>): void
  onBlur?(data: FocusEvent<HTMLInputElement, Element>): void
}

export const CodeInputField: FC<CodeInputFieldProps> = ({
  className,
  disabled,
  error,
  placeholder,
  value,
  name,
  isCallCode,
  onChange,
  onFocus,
  onBlur,
}) => {
  const t = useTranslations()

  return (
    <>
      <PhoneCodeInput
        name={name}
        value={value}
        isError={Boolean(error)}
        disabled={disabled}
        className={className}
        placeholder={placeholder}
        isCallCode={isCallCode}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      {Boolean(error) && <div className={style.errorWrapper}>{t(error as string)}</div>}
    </>
  )
}

CodeInputField.displayName = 'CodeInputField'
